import "core-js/modules/es6.array.index-of";
export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}